<template>
  <div class="dev-overlay-form-group">
    <h3 class="group-title">
      {{ groupTitle }}
    </h3>
    <div class="group-box">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    groupTitle: {
      type: String,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
.group-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: .75rem;

  &:before {
    content: '> ';
    font-size: .9em;
    font-weight: 400;
  }
}

.group-box {
  background: #F5F6FA;
  border-radius: 5px;
  border: 1px solid #EEE;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
}
</style>
